import React, { useContext } from "react";
import { GlobalSnackBar } from "../snackBar";
import { ApplicationContext } from "../../context/application_ctx";

export const ApplicationWrappers = ({children})=>{
    const {globalSnackBar} = useContext(ApplicationContext)
    return(
        <>
        {children}
        <GlobalSnackBar open={globalSnackBar?.open} title={globalSnackBar?.title}/>
        </>
    )
}